import React from "react";
var __jsx = React.createElement;
import { useConsent } from "@/common/Contexts/Consent/ConsentContext";
import { useTranslation } from "@i18n";
var ModalContent = function ModalContent() {
  var _useConsent = useConsent(),
    consentState = _useConsent.consentState;
  var action__acceptConsent = useConsent().actions.action__acceptConsent;
  var consentInfo = consentState.consentInfo;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "px-4 pt-9 pb-4 h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary text-start text-2xl font-bold"
  }, consentInfo === null || consentInfo === void 0 ? void 0 : consentInfo.title), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-text text-base font-normal"
  }, consentInfo === null || consentInfo === void 0 ? void 0 : consentInfo.subtitle)), /*#__PURE__*/React.createElement("div", {
    className: "rounded flex-1 p-4  border border-solid border-[#BEBEBE] max-h-full overflow-y-scroll md:max-h-[375px]",
    dangerouslySetInnerHTML: {
      __html: consentInfo === null || consentInfo === void 0 ? void 0 : consentInfo.content
    }
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    className: "w-full bg-primary outline-0 border-0 text-white text-base font-bold py-2.5 px-4 rounded",
    onClick: function onClick() {
      action__acceptConsent().then(function () {});
    }
  }, tShort("consent/accept_button", {
    ns: "web_common"
  }))))));
};
export default ModalContent;